/*This function is used to display the SVG logos in the footer. Each logo is in 
its own seperate element, which is displayed in the return.  
The SVG's are taken from Sainsbury's website and converted so they can be used
in React by https://react-svgr.com/playground/ */


function FooterSvgContainer() {


const facebook = (
  <div className="fbContainer">
    <svg
      width={25}
      height={25}
      viewBox="0 0 30 30"
      fill="none"
      className="fb"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{"Facebook icon"}</title>
      <path
        d="M30 15c0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 7.487 5.485 13.692 12.656 14.818V19.336H8.848V15h3.808v-3.305c0-3.76 2.24-5.836 5.666-5.836 1.641 0 3.358.293 3.358.293v3.692h-1.892c-1.863 0-2.444 1.156-2.444 2.342V15h4.16l-.665 4.336h-3.495v10.482C24.514 28.692 30 22.487 30 15Z"
        fill="#404040"
      />
      <path
        d="M20.839 19.336 21.504 15h-4.16v-2.814c0-1.186.581-2.342 2.444-2.342h1.892V6.152s-1.717-.293-3.358-.293c-3.426 0-5.666 2.077-5.666 5.836V15H8.848v4.336h3.808v10.482a15.116 15.116 0 0 0 4.688 0V19.336h3.495Z"
        fill="#fff"
      />
    </svg>
  </div>
);

const twitter = (
  <div className="twitterContainer">
    <svg
      width={25}
      height={25}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="twitter"
    >
      <title>{"Twitter icon"}</title>
      <path
        d="M30 15c0 8.288-6.712 15-15 15-8.287 0-15-6.712-15-15C0 6.713 6.713 0 15 0c8.288 0 15 6.713 15 15Zm-17.745 7.913c6.652 0 10.29-5.513 10.29-10.29 0-.158 0-.316-.008-.465a7.41 7.41 0 0 0 1.808-1.875 7.34 7.34 0 0 1-2.078.57 3.614 3.614 0 0 0 1.59-2.003 7.324 7.324 0 0 1-2.294.877 3.6 3.6 0 0 0-2.64-1.14 3.617 3.617 0 0 0-3.615 3.616c0 .285.03.562.097.825a10.26 10.26 0 0 1-7.455-3.78 3.628 3.628 0 0 0-.487 1.815 3.6 3.6 0 0 0 1.612 3.007 3.553 3.553 0 0 1-1.635-.45v.045a3.62 3.62 0 0 0 2.902 3.547 3.605 3.605 0 0 1-1.635.06 3.611 3.611 0 0 0 3.375 2.513 7.27 7.27 0 0 1-5.355 1.492 10.076 10.076 0 0 0 5.528 1.636Z"
        fill="#fff"
      />
    </svg>
  </div>
);

const youtube = (
  <div className="youtubeContainer">
    <svg
      width={25}
      height={25}
      viewBox="0 0 30 22"
      fill="#404040"
      xmlns="http://www.w3.org/2000/svg"
      className="youtube"
    >
      <title>{"YouTube icon"}</title>
      <path
        d="M29.373 3.3A3.77 3.77 0 0 0 26.72.63C24.38 0 15 0 15 0S5.618 0 3.28.63A3.77 3.77 0 0 0 .627 3.3C0 5.656 0 10.568 0 10.568s0 4.913.627 7.268a3.77 3.77 0 0 0 2.653 2.67c2.338.63 11.72.63 11.72.63s9.382 0 11.72-.63a3.77 3.77 0 0 0 2.653-2.67C30 15.481 30 10.568 30 10.568s0-4.912-.627-7.268Z"
        fill="#fff"
      />
      <path d="m11.932 15.029 7.84-4.46-7.84-4.462v8.922Z" fill="#000" />
    </svg>
  </div>
);

const instagram = (
  <div className="instragramContainer">
    <svg
      width={25}
      height={25}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="instagram"
    >
      <title>{"Instagram icon"}</title>
      <path
        d="M15 2.899c3.942 0 4.408.015 5.965.086 1.439.065 2.22.306 2.74.508.69.268 1.182.587 1.698 1.104a4.565 4.565 0 0 1 1.104 1.697c.202.52.443 1.302.508 2.741.071 1.556.086 2.023.086 5.965 0 3.942-.015 4.408-.086 5.965-.065 1.439-.306 2.22-.508 2.74a4.58 4.58 0 0 1-1.104 1.698 4.565 4.565 0 0 1-1.697 1.104c-.52.202-1.302.443-2.741.508-1.556.071-2.023.086-5.965.086-3.942 0-4.409-.015-5.965-.086-1.439-.065-2.22-.306-2.74-.508a4.58 4.58 0 0 1-1.698-1.104 4.565 4.565 0 0 1-1.104-1.697c-.202-.52-.443-1.302-.508-2.741-.071-1.556-.086-2.023-.086-5.965 0-3.942.015-4.408.086-5.965.065-1.439.306-2.22.508-2.74a4.58 4.58 0 0 1 1.104-1.698 4.565 4.565 0 0 1 1.697-1.104c.52-.202 1.302-.443 2.741-.508 1.557-.071 2.023-.086 5.965-.086Zm0-2.66c-4.009 0-4.512.017-6.086.09-1.571.07-2.645.32-3.583.685a7.23 7.23 0 0 0-2.615 1.703A7.24 7.24 0 0 0 1.014 5.33C.649 6.269.399 7.343.327 8.914.256 10.488.24 10.99.24 15s.017 4.512.09 6.086c.07 1.571.32 2.644.685 3.583a7.23 7.23 0 0 0 1.703 2.615 7.233 7.233 0 0 0 2.614 1.702c.94.365 2.013.615 3.583.686 1.575.072 2.078.09 6.087.09 4.008 0 4.511-.018 6.086-.09 1.57-.071 2.644-.32 3.583-.686a7.228 7.228 0 0 0 2.614-1.702 7.235 7.235 0 0 0 1.703-2.615c.365-.939.615-2.012.686-3.583.072-1.574.09-2.077.09-6.086s-.018-4.512-.09-6.086c-.071-1.571-.321-2.645-.686-3.583a7.23 7.23 0 0 0-1.703-2.615 7.234 7.234 0 0 0-2.614-1.702C23.73.649 22.658.399 21.087.327 19.512.256 19.009.24 15 .24Z"
        fill="#fff"
      />
      <path
        d="M15 7.42a7.58 7.58 0 1 0 0 15.16 7.58 7.58 0 0 0 0-15.16Zm0 12.5a4.92 4.92 0 1 1 0-9.84 4.92 4.92 0 0 1 0 9.84ZM22.88 8.891a1.771 1.771 0 1 0 0-3.542 1.771 1.771 0 0 0 0 3.542Z"
        fill="#fff"
      />
    </svg>
  </div>
);

const pinterest = (
  <div className="pinterestContainer">
    <svg
      width={25}
      height={25}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="pinterest"
    >
      <title>{"Pinterest icon"}</title>
      <g clip-path="URL(#clip0)">
        <path
          d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
          fill="white"
        ></path>
        <path
          d="M15 0C6.71605 0 0 6.71605 0 15C0 21.358 3.95062 26.7901 9.53086 28.9753C9.39506 27.7901 9.28395 25.963 9.58025 24.6667C9.85185 23.4938 11.3333 17.2099 11.3333 17.2099C11.3333 17.2099 10.8889 16.3086 10.8889 14.9877C10.8889 12.9012 12.0988 11.3457 13.6049 11.3457C14.8889 11.3457 15.5062 12.3086 15.5062 13.4568C15.5062 14.7407 14.6914 16.6667 14.2593 18.4568C13.9012 19.9506 15.0123 21.1728 16.4815 21.1728C19.1481 21.1728 21.1975 18.358 21.1975 14.3086C21.1975 10.716 18.6173 8.20988 14.9259 8.20988C10.6543 8.20988 8.14815 11.4074 8.14815 14.716C8.14815 16 8.64197 17.3827 9.25926 18.1358C9.38272 18.284 9.39506 18.4198 9.35802 18.5679C9.24691 19.037 8.98765 20.0617 8.93827 20.2716C8.87654 20.5432 8.71605 20.6049 8.4321 20.4691C6.55556 19.5926 5.38272 16.8642 5.38272 14.6543C5.38272 9.92593 8.81481 5.58025 15.2963 5.58025C20.4938 5.58025 24.5432 9.28395 24.5432 14.2469C24.5432 19.4198 21.2839 23.5802 16.7654 23.5802C15.2469 23.5802 13.8148 22.7901 13.3333 21.8519C13.3333 21.8519 12.5802 24.716 12.3951 25.4198C12.0617 26.7284 11.1481 28.358 10.5309 29.358C11.9383 29.7901 13.4198 30.0247 14.9753 30.0247C23.2593 30.0247 29.9753 23.3086 29.9753 15.0247C30 6.71605 23.2839 0 15 0Z"
          fill="#404040"
        ></path>
      </g>
      <path
        d="M15 0C6.716 0 0 6.716 0 15c0 6.358 3.95 11.79 9.53 13.975-.135-1.185-.246-3.012.05-4.308a4783.55 4783.55 0 0 1 1.753-7.457s-.444-.901-.444-2.222c0-2.087 1.21-3.642 2.716-3.642 1.284 0 1.901.963 1.901 2.11 0 1.285-.815 3.21-1.247 5-.358 1.495.753 2.717 2.223 2.717 2.666 0 4.716-2.815 4.716-6.864 0-3.593-2.58-6.1-6.272-6.1-4.272 0-6.778 3.198-6.778 6.507 0 1.284.494 2.667 1.111 3.42a.447.447 0 0 1 .099.432c-.111.469-.37 1.494-.42 1.704-.061.271-.222.333-.506.197-1.876-.876-3.05-3.605-3.05-5.815 0-4.728 3.433-9.074 9.914-9.074 5.198 0 9.247 3.704 9.247 8.667 0 5.173-3.26 9.333-7.778 9.333-1.518 0-2.95-.79-3.432-1.728l-.938 3.568c-.333 1.308-1.247 2.938-1.864 3.938 1.407.432 2.889.667 4.444.667 8.284 0 15-6.716 15-15C30 6.716 23.284 0 15 0Z"
        fill="#404040"
      />
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h38v38H0z" />
        </clipPath>
      </defs>
    </svg>
  </div>
)


/*Arrau to store the URLs for the SVG and the actual SVG. */
const svg = [
  ["https://www.facebook.com/sainsburys", facebook],
  ["https://twitter.com/Sainsburys", twitter],
  ["https://www.youtube.com/user/Sainsburys", youtube],
  ["https://www.instagram.com/sainsburys/", instagram],
  ["https://www.pinterest.co.uk/sainsburys/" , pinterest],
]

/*Map method to return the SVG logos within an anchor tag.  */

const svgList = svg.map((item, index)=>{
 return <a key={index} href={item[0]} target="blank">{item[1]}</a>

})

/*The map is returned */


return (
    <div className="footerSvgContainer">
      {svgList}
    </div>
  );
}



export default FooterSvgContainer;
